import {applyMiddleware, createStore, Store} from 'redux';
import thunk from 'redux-thunk';

import {ApplicationState, appReducer, createAction, UserStoreState} from "./user/UserStore";

export interface AppState {
    user : UserStoreState;
}
let store : Store<ApplicationState>;
export function configureStore() {
     store =  createStore(appReducer, applyMiddleware(thunk));
     return store;
}

export function getStore() : Store<ApplicationState> {
    return store;
}
export function createAndDispatch<T>(type : any, payload : T) {
    return store.dispatch(createAction(type, payload));
}